import { Routes } from '@angular/router';
import { AboutComponent } from './components/albcode/about/about.component';
import { CRMComponent } from './components/albcode/crm/crm.component';
import { FAQComponent } from './components/albcode/faq/faq.component';
import { ImmoconnectComponent } from './components/albcode/immoconnect/immoconnect.component';
import { KiAgentenComponent } from './components/albcode/ki-agenten/ki-agenten.component';
import { ReferenzenComponent } from './components/albcode/referenzen/referenzen.component';
import { SoftwaremodernisierungComponent } from './components/albcode/softwaremodernisierung/softwaremodernisierung.component';
import { Typo3WebseitenComponent } from './components/albcode/typo3-webseiten/typo3-webseiten.component';
import { WebportaleComponent } from './components/albcode/webportale/webportale.component';
import { ContactComponent } from './components/contact/contact.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { DatenschutzComponent } from './components/footer/datenschutz/datenschutz.component';
import { ImpressumComponent } from './components/footer/impressum/impressum.component';
import { HomeComponent } from './components/home/home.component';
import { LexofficeComponent } from './components/partner/software-partner/lexoffice/lexoffice.component';
import { SoftwarePartnerComponent } from './components/partner/software-partner/software-partner.component';
import { UnternehmensPartnerComponent } from './components/partner/unternehmens-partner/unternehmens-partner.component';
import { TicketSystemComponent } from './components/ticket-system/ticket-system.component';
import { SeoGuard } from './guards/seo.guard';
import { techblogRoutes } from './techblog.routes';

export const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
        pathMatch: 'full',
        data: {
            title: $localize`Softwareentwicklung, Webportale & Modernisierung in Hechingen`,
            desc: $localize`AlbCode entwickelt individuelle Businesssoftware, Webportale und TYPO3-Webseiten, modernisiert Anwendungen und realisiert KI-Agenten für Unternehmen.`,
            keywords: [
                $localize`Softwareentwicklung Hechingen`,
                $localize`Webentwicklung Hechingen`,
                $localize`Software Zollern-Alb-Kreis`,
                $localize`Webentwicklung Zollern-Alb-Kreis`,
                $localize`individuelle Businesssoftware`,
                $localize`Webportal Entwicklung`,
                $localize`Kundenportal entwickeln`,
                $localize`Mitarbeiterportal entwickeln`,
                $localize`Legacy Software modernisieren`,
                $localize`Businesssoftware modernisieren`,
                $localize`Softwaremigration Unternehmen`,
                $localize`Altsystem ablösen`,
                $localize`Prozessdigitalisierung`,
                $localize`Schnittstellenentwicklung`,
                $localize`TYPO3 Webseiten Hechingen`,
                $localize`KI Agenten Unternehmen`,
                $localize`KI Beratung Hechingen`,
                $localize`AlbCode`
            ]
        },
        canActivate: [SeoGuard]
    },
    {
        path: 'home',
        redirectTo: '',
        pathMatch: 'full'
    },
    {
        path: 'albcode',
        children: [
            {
                path: 'about',
                component: AboutComponent,
                data: {
                    title: $localize`AlbCode - Softwareunternehmen aus Hechingen`,
                    desc: $localize`AlbCode entwickelt individuelle Businesssoftware und Webportale und modernisiert bestehende Anwendungen für Unternehmen in der Region und darüber hinaus.`,
                    keywords: [$localize`Softwareunternehmen Hechingen`, $localize`IT-Unternehmen Hechingen`, $localize`Softwareentwicklung Zollern-Alb-Kreis`, $localize`Businesssoftware`, $localize`Webportale`, $localize`Softwaremodernisierung`, $localize`AlbCode`]
                },
                canActivate: [SeoGuard]
            },
            {
                path: 'referenzen',
                component: ReferenzenComponent,
                data: {
                    title: $localize`AlbCode - Unsere Referenzen`,
                    desc: $localize`Unsere Referenzprojekte zeigen, wie wir maßgeschneiderte IT-Lösungen erfolgreich umgesetzt haben.`,
                    keywords: [$localize`AlbCode Referenzen`, $localize`Software Referenzen`, $localize`Webentwicklung Referenzen`, $localize`Kundenprojekte`, $localize`IT-Projekte`]
                },
                canActivate: [SeoGuard]
            },
            {
                path: 'webportale',
                component: WebportaleComponent,
                data: {
                    title: $localize`Individuelle Webportale für Unternehmen`,
                    desc: $localize`AlbCode entwickelt sichere Kundenportale, Mitarbeiterportale und Prozessportale mit individuellen Workflows und Schnittstellen zu bestehenden Systemen.`,
                    keywords: [
                        $localize`Webportal entwickeln lassen`,
                        $localize`individuelle Webportale`,
                        $localize`Kundenportal Entwicklung`,
                        $localize`Mitarbeiterportal Entwicklung`,
                        $localize`B2B Portal entwickeln`,
                        $localize`Prozessportal Unternehmen`,
                        $localize`Business Webanwendung`,
                        $localize`Webportal Hechingen`,
                        $localize`Webentwicklung Zollern-Alb-Kreis`
                    ]
                },
                canActivate: [SeoGuard]
            },
            {
                path: 'softwaremodernisierung',
                component: SoftwaremodernisierungComponent,
                data: {
                    title: $localize`Legacy-Software & Businesssoftware modernisieren`,
                    desc: $localize`AlbCode modernisiert veraltete Businesssoftware und überführt bewährte Workflows, Daten und Schnittstellen in sichere, wartbare Webanwendungen.`,
                    keywords: [
                        $localize`Legacy Software modernisieren`,
                        $localize`Businesssoftware modernisieren`,
                        $localize`Altsystem ablösen`,
                        $localize`Softwaremigration Unternehmen`,
                        $localize`Legacy Anwendung migrieren`,
                        $localize`veraltete Software ersetzen`,
                        $localize`Desktop Anwendung modernisieren`,
                        $localize`Software Reengineering`,
                        $localize`Anwendungsmodernisierung`
                    ]
                },
                canActivate: [SeoGuard]
            },
            {
                path: 'typo3-webseiten',
                component: Typo3WebseitenComponent,
                data: {
                    title: $localize`TYPO3-Webseiten & Webseitenpflege für Unternehmen`,
                    desc: $localize`AlbCode entwickelt, modernisiert und pflegt TYPO3-Webseiten für Unternehmen – inklusive Updates, Erweiterungen, SEO, Performance und persönlicher Betreuung.`,
                    image: 'https://www.albcode.de/freepics/coding.jpg',
                    keywords: [
                        $localize`TYPO3 Webseite erstellen lassen`,
                        $localize`TYPO3 Agentur Hechingen`,
                        $localize`TYPO3 Webseitenpflege`,
                        $localize`TYPO3 Wartung`,
                        $localize`TYPO3 Updates`,
                        $localize`TYPO3 Relaunch`,
                        $localize`TYPO3 Betreuung Unternehmen`,
                        $localize`Unternehmenswebseite erstellen`,
                        $localize`Webseitenpflege Zollern-Alb-Kreis`,
                        $localize`Webdesign Hechingen`
                    ]
                },
                canActivate: [SeoGuard]
            },
            {
                path: 'ki-agenten',
                component: KiAgentenComponent,
                data: {
                    title: $localize`KI-Agenten entwickeln & KI-Beratung für Unternehmen`,
                    desc: $localize`AlbCode entwickelt individuelle KI-Agenten und unterstützt Unternehmen bei Auswahl, Integration und sicherer Einführung praxistauglicher KI-Lösungen.`,
                    image: 'https://www.albcode.de/freepics/network.jpg',
                    keywords: [
                        $localize`KI Agenten entwickeln lassen`,
                        $localize`KI Beratung Unternehmen`,
                        $localize`KI Agentur Hechingen`,
                        $localize`individuelle KI Assistenten`,
                        $localize`KI Automatisierung Unternehmen`,
                        $localize`KI Integration bestehende Software`,
                        $localize`KI Wissensassistent`,
                        $localize`KI Dokumentenverarbeitung`,
                        $localize`KI Agent Zollern-Alb-Kreis`,
                        $localize`künstliche Intelligenz Beratung`
                    ]
                },
                canActivate: [SeoGuard]
            },
            {
                path: 'crm',
                component: CRMComponent,
                data: {
                    title: $localize`AlbCode CRM – CRM mit Kalender, Zeiterfassung & Android-App`,
                    desc: $localize`AlbCode CRM verbindet Kunden, Projekte, Aufgaben, E-Mails und Dokumente mit Teamkalender, Projektzeiterfassung und nativer Android-Kalender-App.`,
                    keywords: [
                        $localize`AlbCode CRM`,
                        $localize`webbasiertes CRM`,
                        $localize`CRM für kleine Unternehmen`,
                        $localize`CRM System`,
                        $localize`Kundenverwaltung Software`,
                        $localize`Aufgabenmanagement Tool`,
                        $localize`Projektmanagement CRM`,
                        $localize`E-Mail Integration CRM`,
                        $localize`Vorgangsverwaltung`,
                        $localize`Dokumentenmanagement CRM`,
                        $localize`CRM mit Kalender`,
                        $localize`CRM mit Zeiterfassung`,
                        $localize`Projektzeiterfassung Software`,
                        $localize`CRM Android App`,
                        $localize`Kalender App Android Unternehmen`,
                        $localize`Teamkalender CRM`,
                        $localize`sichere Webanwendung`,
                        $localize`teamübergreifende CRM Lösung`,
                        $localize`flexible CRM Software`,
                        $localize`von überall zugänglich`,
                        $localize`individuelle CRM Anpassung`
                    ]
                },
                canActivate: [SeoGuard]
            },
            {
                path: 'immobilienverwaltung',
                component: ImmoconnectComponent,
                data: {
                    title: $localize`ImmoConnect – Software für Immobilienverwaltung & digitale Objektakten`,
                    desc: $localize`ImmoConnect bündelt Objekte, Wohneinheiten, Schäden, Aufgaben, E-Mails, Dokumente und Termine in einer webbasierten Software für Immobilienverwaltungen.`,
                    keywords: [
                        $localize`ImmoConnect`,
                        $localize`Immobilienverwaltungssoftware`,
                        $localize`Software für Immobilienverwaltung`,
                        $localize`Hausverwaltungssoftware`,
                        $localize`digitale Objektakte`,
                        $localize`digitale Immobilienverwaltung`,
                        $localize`Objektverwaltung Software`,
                        $localize`Wohneinheiten verwalten`,
                        $localize`Schadensmanagement Immobilien`,
                        $localize`Schadensverwaltung Hausverwaltung`,
                        $localize`Dokumentenmanagement Immobilienverwaltung`,
                        $localize`E-Mail Integration Hausverwaltung`,
                        $localize`Aufgabenmanagement Hausverwaltung`,
                        $localize`Kalender Immobilienverwaltung`,
                        $localize`Android Kalender App Hausverwaltung`,
                        $localize`Immobilien CRM`,
                        $localize`Hausverwaltung digitalisieren`
                    ]
                },
                canActivate: [SeoGuard]
            },
            {
                path: 'immoconnect',
                redirectTo: 'immobilienverwaltung',
                pathMatch: 'full'
            },
            {
                path: 'faq',
                component: FAQComponent,
                data: {
                    title: $localize`AlbCode - Häufig gestellte Fragen (FAQ)`,
                    keywords: [$localize`FAQ`, $localize`Häufig gestellte Fragen`, $localize`AlbCode FAQ`],
                    desc: $localize`Hier finden Sie Antworten auf häufig gestellte Fragen zu unseren Dienstleistungen und unserem Unternehmen.`
                },
                canActivate: [SeoGuard]
            },
            ...techblogRoutes
        ],
        canActivate: [SeoGuard]
    },
    {
        path: 'partner',
        children: [
            {
                path: 'software',
                children: [
                    {
                        path: '',
                        component: SoftwarePartnerComponent,
                        data: {
                            title: $localize`AlbCode - Unsere Software-Partner`,
                            desc: $localize`Unsere Software-Partner liefern bewährte Lösungen für Formulare, Buchhaltung und IT-Sicherheit - sinnvoll integriert durch AlbCode.`,
                            keywords: [$localize`Software-Partner`, $localize`Jotform`, $localize`Jotform Solutions Partner`, $localize`Lexware Office`, $localize`Lexware Office Integrationspartner`, $localize`Hornetsecurity`]
                        },
                        canActivate: [SeoGuard]
                    },
                    {
                        path: 'lexoffice',
                        component: LexofficeComponent,
                        data: {
                            title: $localize`AlbCode - Ihr Integrationspartner für Lexware Office`,
                            desc: $localize`AlbCode integriert Lexware Office professionell in Ihre Prozesse und entwickelt passgenaue Schnittstellen zu bestehenden Anwendungen.`,
                            keywords: [$localize`Lexware Office`, $localize`Lexware Office Integrationspartner`, $localize`elektronische Rechnung`, $localize`eRechnung`, $localize`Buchhaltungssoftware`]
                        },
                        canActivate: [SeoGuard]
                    },
                ]
            },
            {
                path: 'unternehmen',
                component: UnternehmensPartnerComponent,
                data: {
                    title: $localize`AlbCode - Unsere Partner-Unternehmen`,
                    desc: $localize`Lernen Sie unsere Partner-Unternehmen kennen: gemeinsam realisieren wir sichere, nachhaltige und passgenaue IT-Lösungen.`,
                    keywords: [$localize`Partner-Unternehmen`, $localize`IT Partner`, $localize`CodeLab`, $localize`Ana Peterfaj`, $localize`IT Cowboys`, $localize`Michael Haug`, $localize`mhg PROTECTIT`, $localize`Larissa Haug`]
                },
                canActivate: [SeoGuard]
            }
        ],
        canActivate: [SeoGuard]
    },
    {
        path: 'ticketsystem',
        component: TicketSystemComponent,
        data: {
            title: $localize`AlbCode - Unser Ticketsystem und Kontaktformular`,
            desc: $localize`Senden Sie Ihre Anfrage schnell über das AlbCode Ticketsystem. Wir melden uns zeitnah mit einer passenden Lösung.`,
            keywords: [$localize`Ticketsystem`, $localize`Kontaktformular`, $localize`Support Anfrage`, $localize`IT Support`, $localize`AlbCode Ticket`]
        },
        canActivate: [SeoGuard]
    },
    {
        path: 'contact',
        component: ContactComponent,
        data: {
            title: $localize`Ihr Kontakt zu AlbCode`,
            desc: $localize`Kontaktieren Sie AlbCode per E-Mail, Telefon oder Anfahrt. Wir beraten Sie persönlich zu Software- und Webprojekten.`,
            keywords: [$localize`AlbCode Kontakt`, $localize`AlbCode Adresse`, $localize`Anfahrt AlbCode`, $localize`Kontakt Hechingen`, $localize`IT Beratung Kontakt`]
        },
        canActivate: [SeoGuard]
    },
    {
        path: 'impressum',
        component: ImpressumComponent,
        canActivate: [SeoGuard]
    },
    {
        path: 'datenschutz',
        component: DatenschutzComponent,
        canActivate: [SeoGuard]
    },
    {
        path: 'not-found',
        component: ErrorPageComponent,
        data: {
            title: $localize`404 - Seite nicht gefunden`,
            desc: $localize`Die angeforderte Seite wurde nicht gefunden.`
        },
        canActivate: [SeoGuard]
    },
    {
        path: '**',
        redirectTo: '/not-found'
    }
];
